import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/Home'

Vue.use(Router)

export default new Router({
  // mode: "history",
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/Register.vue')
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('@/pages/Support.vue')
    },
    {
      path: '/successCase',
      name: 'successCase',
      component: () => import('@/pages/SuccessCase.vue')
    },
    {
      path: '/questionnaire',
      name: 'questionnaire',
      component: () => import('@/pages/Questionnaire.vue')
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import('@/pages/Partners.vue')
    },
    {
      path: '/management',
      name: 'management',
      component: () => import('@/pages/Management.vue')
    },
    {
      path: '/manageDeveloper',
      name: 'manageDeveloper',
      component: () => import('@/pages/ManageDeveloper.vue')
    },
    {
      path: '/shop',
      name: 'shop',
      component: () => import('@/pages/Shop.vue')
    },
    {
      path: '/appMarket',
      name: 'appMarket',
      component: () => import('@/pages/ApplicationMarket.vue')
    },
    {
      path: '/allApps',
      name: 'allApps',
      component: () => import('@/pages/AllApps.vue')
    },
    {
      path: '/workbench',
      name: 'workbench',
      component: () => import('@/pages/Workbench.vue')
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: () => import('@/pages/PersonalCenter.vue')
    },
    {
      path: '/myCloudService',
      name: 'myCloudService',
      component: () => import('@/pages/myCloudService.vue')
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: () => import('@/pages/ResetPassword.vue')
    },
    {
      path: '/contactUS',
      name: 'contactUS',
      component: () => import('@/pages/ContactUS.vue')
    },
    {
      path: '/appDetails',
      name: 'appDetails',
      component: () => import('@/pages/AppDetails.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js